import { __assign, __extends } from "tslib";
// DS: I71
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Calendar.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("defs", null,
                    React.createElement("path", { d: "M14.452 1.545h-.773V0h-1.546v1.545H3.875V0H2.329v1.545h-.772A1.55 1.55 0 0 0 .01 3.091v11.322c0 .85.696 1.545 1.546 1.545h12.895a1.55 1.55 0 0 0 1.545-1.545V3.09a1.55 1.55 0 0 0-1.545-1.546zM14.019 14H2V5h12.019v9z", id: "I71-a" })),
                React.createElement("g", { transform: "translate(4 4)", fill: "currentColor", fillRule: "evenodd" },
                    React.createElement("use", { fillRule: "nonzero", xlinkHref: "#I71-a" }),
                    React.createElement("path", { d: "M4 7h2v2H4zM4 10h2v2H4zM7 7h2v2H7zM7 10h2v2H7zM10 7h2v2h-2zM10 10h2v2h-2z" })))));
    };
    return Calendar;
}(React.Component));
export { Calendar };
export default Calendar;
//# sourceMappingURL=Calendar.js.map